module.exports = __webpack_public_path__ + "img/upload-nose-print.7e24803f.jpg";